<template>
  <div class="switch-dept">
    <el-dialog
      width="620px"
      title="切换岗位"
      :visible.sync="showDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-col class="empty" v-if="!myDeptList.length && !showLoading"
        >暂无数据</el-col
      >
      <div class="dept-list" v-else v-loading="showLoading">
        <el-radio-group v-model="checkedDept" size="large">
          <el-row v-for="item in myDeptList" :key="item.deptId">
            <el-radio :label="item.deptId" border>{{ item.deptName }}</el-radio>
          </el-row>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="!myDeptList.length"
          @click="confirmSwitchDept"
           v-throttle>保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getMyDeptList, saveSwitchDept } from '@/api/user';
  export default {
    name: 'switch-dept',
    data() {
      return {
        showDialog: false,
        showLoading: false,
        myDeptList: [],
        currentDept: '',
        checkedDept: null
      };
    },
    methods: {
      open() {
        this.currentDept = localFun.get('deptId');
        this.checkedDept = localFun.get('deptId')
          ? JSON.parse(localFun.get('deptId'))
          : null;
        this.getMyDeptList();
        this.showDialog = true;
      },
      async getMyDeptList() {
        try {
          this.showLoading = true;
          const { data } = await getMyDeptList();
          this.myDeptList = data;
          this.showLoading = false;
        } catch (error) {
          this.showLoading = false;
          this.Sentry.captureException(error);
        }
      },
      async confirmSwitchDept() {
        try {
          if (
            this.currentDept &&
            JSON.parse(this.currentDept) !== this.checkedDept
          ) {
            // 切换辖区
            await saveSwitchDept({
              switchDeptId: this.checkedDept
            });
            const currentDeptInfo =
              this.myDeptList.find((item) => {
                return item.deptId === this.checkedDept;
              }) || {};
            const userInfo = JSON.parse(localFun.get('userInfo') || '{}');
            if (currentDeptInfo.deptName) {
              userInfo.currentDepartmentName = currentDeptInfo.deptName;
              localFun.set('userInfo', JSON.stringify(userInfo));
              this.$emit('setUserDept', currentDeptInfo.deptName);
            }
            localFun.set('deptId', this.checkedDept + '');
          }
          this.showDialog = false;
          this.$router.go(0);
        } catch (error) {
          this.Sentry.captureException(error);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  ::v-deep .el-dialog {
    border-radius: 8px 8px 8px 8px;
    .el-dialog__body {
      border-top: 2px solid #f6f6f6;
      padding: 16px 24px !important;
      .el-row {
        margin-bottom: 8px;
      }
    }
  }
  ::v-deep .is-bordered {
    width: 574px !important;
    padding: 12px !important;
    box-sizing: border-box;
    height: auto;
  }
  ::v-deep .el-radio__label {
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
    padding-right: 18px;
  }

  .switch-dept {
    max-height: 320px;
    overflow-y: auto;
  }
  .empty {
    text-align: center;
    line-height: 260px;
    font-size: 14px;
    color: #999;
  }
</style>
